import * as React from 'react'
import { useTranslation } from '~/hooks/useTranslation'
import parse from 'html-react-parser'
import { AttachmentLink } from './AttachmentCell'

export function ExpandedCell({ row }) {
  const { t } = useTranslation('ExpandedCell')
  const feedback = row.original
  const candidateMessage = feedback.content?.message
  const coachMessage = feedback.content?.coach_message

  const coachName = feedback.coach_first_name

  return (
    <div className="m-4 flex flex-col gap-1 border-t border-gray-200 p-4">
      <div className="flex flex-col gap-4">
        {candidateMessage && (
          <div>
            <span className="font-bold">{t('message')}:</span>{' '}
            <p>{candidateMessage}</p>
          </div>
        )}
        {coachMessage && (
          <div className="flex flex-col gap-2">
            <div>
              <span className="font-bold">{t('feedback', { coachName })}:</span>{' '}
              {parse(parse(coachMessage))}
            </div>
            <AttachmentLink feedback={feedback} />
          </div>
        )}
      </div>
    </div>
  )
}
